"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getXmlAsStringByPath = exports.parseStringResponse = exports.parseModelArray = exports.parseModel = exports.parseKey = void 0;

var _lodash = require("lodash");

var _xml2js = require("xml2js");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Converts a raw JSON-converted XML node as defined by schema
 * @param raw - JSON-converted XML node from xml2js
 * @param schema - a { key: {schema} } formatted object that determines conversion.
 *     key: {type, path} - Extracts a value of {type} from {path}
 *     key: {model, path} - Injects a {model} (or an array of{model} ) from {path}
 *     key: {function(raw, context)} - Injects whatever is returned from {function}
 * @param context - The root node of the model being constructed. Useful for...? TODO: What?
 * @returns {*}
 */
var parseKey = function parseKey(raw, schema, context) {
  var rv;

  if (typeof schema === 'function') {
    rv = schema(raw, context);
  } else if (schema.model) {
    var list = (0, _lodash.get)(raw, schema.path);

    if (Array.isArray(list)) {
      if (schema.key) {
        rv = {};
        list.forEach(function (item) {
          var model = parseModel(item, schema.model);
          rv[model[schema.key]] = model;
        });
      } else {
        rv = list.map(function (item) {
          return parseModel(item, schema.model);
        });
      }
    } else if (_typeof(list) === 'object') {
      rv = parseModel(list, schema.model);
    } // else; treating empty strings as undefined

  } else {
    var value = (0, _lodash.get)(raw, schema.path);

    if (value !== undefined) {
      if (_typeof(value) === 'object' && value.$) {
        if (value.$['xsi:nil'] && value.$['xsi:nil'] === 'true') {
          rv = null;
        }
      } else {
        if (schema.type === Boolean) {
          rv = Boolean(value === 'true' || value === true);
        } else {
          rv = schema.type ? schema.type(value) : value;
        }
      }
    }
  }

  return rv;
};
/**
 * Converts JSON-converted XML from xml2js lib to a model
 * @param raw
 * @param model
 * @returns {{}}
 */


exports.parseKey = parseKey;

var parseModel = function parseModel(raw, model) {
  var out = {};
  Object.keys(model).forEach(function (key) {
    var schema = model[key];
    var value = parseKey(raw, schema, out);

    if (value !== undefined) {
      out[key] = value;
    }
  });
  return out;
};
/**
 * Converts JSON-converted XML array from xml2js lib to an array of models
 * @param raw
 * @param model
 * @param path - root node where array can be found
 * @returns {*}
 */


exports.parseModel = parseModel;

var parseModelArray = function parseModelArray(raw, model, path) {
  var list = (0, _lodash.get)(raw, path);
  return list ? list.map(function (item) {
    return parseModel(item, model);
  }) : undefined;
};
/**
 * Converts a freeform string response ("a|b|c|d", "some random text") into the type of object specified. Most Image
 * Server responses are pipe (|) separated, so the splitter is generally assumed to be a pipe. Some responses are
 * basically english sentences, so RegExps are a better fit.
 * @param {string} raw - response to parse
 * @param {{type, index}} schema - an object with parsing instructions. Type will convert the response and index is where the raw value sits in the response.
 * @param {String || RegExp} splitter - Used to split raw into an array. If String assumed to be a splitter. If RegExp raw.matches() will be used instead
 * @returns {*}
 */


exports.parseModelArray = parseModelArray;

var parseStringResponse = function parseStringResponse(raw, schema) {
  var splitter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '|';
  var parts = splitter instanceof RegExp ? raw.match(splitter).splice(1) : raw.split(splitter);
  return Object.keys(schema).reduce(function (model, key) {
    var itemSchema = schema[key];

    if (itemSchema.demo < parts.length) {
      model[key] = itemSchema.type(parts[itemSchema.demo]);
    }

    return model;
  }, {});
};
/**
 * Gets the XML value back from a JSON-converted XML via xml2js
 * @param raw
 * @param path
 * @param rootName - Builder was changing this
 * @returns {''}
 */


exports.parseStringResponse = parseStringResponse;

var getXmlAsStringByPath = function getXmlAsStringByPath(raw, path, rootName) {
  var xmlBuilder = new _xml2js.Builder({
    headless: true,
    rootName: rootName
  });
  var list = (0, _lodash.get)(raw, path);
  return xmlBuilder.buildObject(list);
};

exports.getXmlAsStringByPath = getXmlAsStringByPath;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/utils/model-builders.js
// module id = 14
// module chunks = 0